import { render } from "./LetterPreviewButton.vue?vue&type=template&id=898eabae"
import script from "./LetterPreviewButton.vue?vue&type=script&lang=js"
export * from "./LetterPreviewButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__